export default function FlagOutlineIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33333 9.33176C3.95642 8.72101 4.79415 8.37891 5.66666 8.37891C6.53917 8.37891 7.3769 8.72101 8 9.33176C8.62309 9.94252 9.46082 10.2846 10.3333 10.2846C11.2058 10.2846 12.0436 9.94252 12.6667 9.33176V3.33176C12.0436 3.94252 11.2058 4.28462 10.3333 4.28462C9.46082 4.28462 8.62309 3.94252 8 3.33176C7.3769 2.72101 6.53917 2.37891 5.66666 2.37891C4.79415 2.37891 3.95642 2.72101 3.33333 3.33176V9.33176ZM3.33333 9.33176V13.9984"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
